import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../../../theme';

const { colors, fonts, fontSize } = redesignTheme;

export const useMinorResultHorizontalDiagramStyles = makeStyles(() => ({
  horizontalBars: {
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
    width: '100%',
  },
  horizontalBarGroup: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  horizontalBarLabel: {
    paddingTop: 5,
    paddingBottom: 3,
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.sm,
    lineHeight: '16px',
    color: colors.overlay,
    textAlign: 'left',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
  },
  horizontalBarTrack: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    minHeight: 25,
  },
  horizontalBarFill: {
    height: 25,
    borderTopRightRadius: 20,
    borderBottomRightRadius: 20,
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 8,
    boxSizing: 'border-box',
    transition: 'width 0.5s ease',
    minWidth: 0,
  },
  horizontalBarValue: {
    fontFamily: fonts.opensansBold,
    fontSize: fontSize.sm,
    lineHeight: '16px',
    color: colors.white,
    whiteSpace: 'nowrap',
  },
  horizontalBarValueEmpty: {
    color: colors.overlay,
  },
}));
